import React, { useContext } from 'react';
import { IAccordionContext } from './accordion.types';

export const AccordionProvider = React.createContext<IAccordionContext>({} as IAccordionContext);

export const useAccordionContext = () => useContext(AccordionProvider);
